import GenericSkeleton from 'components/skeleton/GenericSkeleton';
import TicketEntry from 'components/ticket/weekly-draw/TicketEntry';
import { useIsMobile } from 'hooks/ui/useIsMobile';
import { useState } from 'react';
import { IEntryLine } from 'types/Draws';
import { LOADING_TIMEOUT } from '../common/constants';
import styles from './TicketStack.module.css';

interface ITicketStackProps {
  entries: IEntryLine[];
}

const TicketStack = ({ entries }: ITicketStackProps) => {
  const { isMobile } = useIsMobile();
  const [expanded, setExpanded] = useState(false);
  const [ticketImageLoaded, setTicketImageLoaded] = useState(false);

  const imageLoaded = (i: number) => {
    if (i === 0) {
      setTimeout(() => {
        setTicketImageLoaded(true);
      }, LOADING_TIMEOUT + 500);
    }
  };

  return (
    <>
      {!ticketImageLoaded && (
        <div className={styles.skeletonContainer}>
          <div className={styles.skeletonWrapper}>
            <GenericSkeleton
              inverseColors
              height={isMobile ? 130 : 180}
              borderRadius={18}
            />
          </div>
        </div>
      )}
      <div
        className={`${styles.container} ${ticketImageLoaded ? styles.ticketLoaded : ''}`}
        style={
          {
            '--ticketStack__offset': expanded ? '-8%' : '-27%',
          } as React.CSSProperties
        }
      >
        {entries.map((entry, i) => (
          <div
            key={i}
            className={styles.ticketWrapper}
            style={{ zIndex: entries.length - i }}
          >
            <TicketEntry entry={entry} imageLoaded={() => imageLoaded(i)} />
          </div>
        ))}

        {entries.length > 1 && (
          <button
            className={`${styles.chevronButton} ${expanded ? styles.chevronButtonRotated : ''}`}
            onClick={() => setExpanded(!expanded)}
          >
            <span className={styles.chevron} />
          </button>
        )}
      </div>
    </>
  );
};

export default TicketStack;
